export const faqHeaderVariants = {
    start: {
        height: 0
    },

    end: {
        height: "20vw",
        transition: {
            ease: "easeOut",
            duration: 1,
            when: "beforeChildren",
            staggerChildren: 0.4
        }
    }
}

